import { render, staticRenderFns } from "./TikTokNotification.vue?vue&type=template&id=6e1e80be&scoped=true"
import script from "./TikTokNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./TikTokNotification.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TikTokNotification.vue?vue&type=style&index=0&id=6e1e80be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1e80be",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default,COverlay: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/COverlay/COverlay.vue').default})
